import { apiNoVersionBase } from 'config/env'

import type { FIActivityResponse } from 'app/dashboard/team_activity/FinancialInsightsReporting/helper'
import { error as logError } from 'app/services/snugLogger'
import { api } from 'app/utils/api/helpers'

export const getFinancialInsightsActivity = (
  teamID: string,
  params: {
    from: string
    to: string
    page?: number
    pageSize?: number
  },
): Promise<FIActivityResponse> => {
  return api
    .get(`/v2/teams/${teamID}/financial-insights/activity`, {
      baseURL: apiNoVersionBase,
      params,
    })
    .then((res: { data: FIActivityResponse }) => res.data)
    .catch((err: unknown) => {
      logError('getFinancialInsightsActivity failed', {
        teamID,
        params,
        err,
      })
      throw err
    })
}
